/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import {
  Index,
  Profile,
  SignIn,
  SignUp,
  ResetPassword,
  Notifications,
  Catalog,
  Product,
  BrandWrapper,
  ProductCreate,
  BrandCreate
} from "@/views"

import multiguard from "vue-router-multiguard"

import {
  requireAdmin,
  requireAuth,
  hasGlobalBrand,
  requireCreateProductRights,
  requireBrandRights
} from "@/utils/middleware"
import ManageUsers from "@/views/ManageUsers"

const Routes = [
  {
    path: "/",
    name: "Accueil",
    component: Index,
    redirect: "/manage",
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",

      appBar: {
        title: "Accueil"
      }
    }
  },
  {
    path: "/manage",
    name: "products",
    beforeEnter: multiguard([requireAuth]),
    redirect: "/manage/catalog"
  },
  {
    path: "/manage/brand/:brand?",
    name: "Brand",
    component: BrandWrapper,
    beforeEnter: multiguard([requireAuth, requireBrandRights]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/manage/new-brand",
    name: "BrandCreate",
    component: BrandCreate,
    beforeEnter: multiguard([requireAuth, requireAdmin]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/manage/catalog",
    name: "Catalog",
    component: Catalog,

    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/manage/catalog/:product",
    name: "Product",
    component: Product,

    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/manage/catalog/product/create",
    name: "ProductCreate",
    component: ProductCreate,

    beforeEnter: multiguard([
      requireAuth,
      hasGlobalBrand,
      requireCreateProductRights
    ]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      appBar: {
        title: "Notifications"
      }
    }
  },
  {
    path: "/manage-users",
    name: "Manage users",
    component: ManageUsers,
    beforeEnter: multiguard([requireAuth, requireAdmin]),
    meta: {
      layout: "default",
      appBar: {
        title: "Manage users"
      }
    }
  }
]

const CommonRoutes = [
  {
    path: "/signin",
    name: "Sign in",
    component: SignIn
  },
  {
    path: "/profile",
    name: "Profil",
    component: Profile,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default",
      appBar: {
        title: "Mon compte"
      }
    }
  },
  {
    path: "/account/password-reset/confirm/:uid/:key",
    component: ResetPassword,
    name: "Reset Password"
  },
  {
    path: "/signup/invite/:key",
    component: SignUp,
    name: "Sign up"
  },
  { path: "*", redirect: "/" }
]

export default [...CommonRoutes, ...Routes]
